import React from 'react';
import styled from 'styled-components';
import backgroundImg from '../../assets/banner.png'; // Import the background image

const Section = styled.section`
  width: 100vw;
  min-height: 25rem;
  position: relative;
  border-top: 2px solid ${props => props.theme.text};
  background-color: ${props => `rgba(${props.theme.textRgba}, 0.9)`};
  background-image: url(${backgroundImg});
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  /* Add black overlay */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Black overlay with 50% opacity */
    z-index: 1;
  }

  @media (max-width: 48em) {
    height: 15em;
    flex-direction: column;
  }
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontxxxl};
  color: ${props => props.theme.body};
  padding: 1rem 2rem;
  z-index: 10; /* Place title above the overlay */
  width: 35%;
  text-transform: capitalize;
  text-shadow: 1px 1px 2px ${props => props.theme.text};
  
  @media (max-width: 64em) {
    font-size: ${props => props.theme.fontxxl};
    width: 40%;
    text-align: center;
  }

  @media (max-width: 48em) {
    font-size: ${props => props.theme.fontxl};
    width: 100%;
    padding: 2rem 0;
  }

  @media (max-width: 30em) {
    font-size: ${props => props.theme.fontbig};
  }
`;

const ButtonContainer = styled.div`
  width: 35%;
  display: flex;
  justify-content: flex-end;
  z-index: 10; /* Place button container above the overlay */
  
  @media (max-width: 48em) {
    width: 100%;
    justify-content: center;
  }
`;

const BannerBtn = styled.a`
  display: inline-block;
  background-color: ${props => props.theme.body};
  color: ${props => props.theme.text};
  outline: none;
  border: none;
  font-weight: 600;
  font-size: ${props => props.theme.fontlg};
  padding: 1.5rem 3rem;
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  text-decoration: none; /* Remove underline */
  transition: all 0.2s ease;

  &:hover {
    transform: scale(0.9);
  }

  &::after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    border: 2px solid ${props => props.theme.body};
    border-radius: 50px;
    width: 100%;
    height: 100%;
    transition: all 0.2s ease;
  }

  &:hover::after {
    transform: translate(-50%, -50%) scale(1);
    padding: 0.3rem;
  }

  @media (max-width: 48em) {
    padding: 1rem 2rem;
  }
  
  @media (max-width: 30em) {
    padding: 0.6rem 1.5rem;
    font-size: ${props => props.theme.fontsm};
  }
`;

function BottomBanner() {
  return (
    <Section>
      <Title>
        Join The <br /> AirEdify Club
      </Title>
      <ButtonContainer>
        <BannerBtn
          href="https://www.airedify.in/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Join Now"
        >
          Join Now
        </BannerBtn>
      </ButtonContainer>
    </Section>
  );
}

export default BottomBanner;
